module.exports = __webpack_public_path__ + "img/jxlb.bc851e2e.png";